import { PageLocatorMap } from '../types/PageLocatorMap';

export const verificationPage = {
  footer: {
    root: 'verification-page.footer.root',
  },
  form: {
    h1: 'verification-page.form.h1',
    h2: 'verification-page.form.h2',
    root: 'verification-page.form.root',
    submitButton: 'verification-page.form.submit-button',
  },
  header: {
    drawerButton: 'verification-page.header.drawer-button',
    root: 'verification-page.header.root',
  },
  progress: {
    root: 'verification-page.progress.root',
  },
} as const satisfies PageLocatorMap;
